import { ZoneManagement } from '~/app/components/zone-management/ZoneManagement';

export const ZoneManagementContainer = () => <ZoneManagement />;
